import { AxiosInstance } from "axios";

const handle402 = (error: any) => {
  const status = error.response?.status;
  const message: string = error.response?.data?.message ?? "";

  if (status === 402) {
    const code = message.replace("SUBSCRIPTION_BLOCKED:", "").trim();
    sessionStorage.setItem("subscription_blocked_code", code);
    window.location.href = "/subscription-blocked";
    throw new Error("SUBSCRIPTION_BLOCKED");
  }

  return Promise.reject(error);
};

export const addSubscriptionInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => handle402(error),
  );
};
